import React, { useState } from 'react';
import { Building2, Briefcase, ChevronRight, X } from 'lucide-react';

const OnboardingModal = ({ onComplete, onSkip }) => {
  const [companyName, setCompanyName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [saving, setSaving] = useState(false);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const resp = await fetch(`${API_URL}/api/auth/profile`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          company_name: companyName || null,
          job_title: jobTitle || null,
        }),
      });
      if (resp.ok) {
        onComplete();
      }
    } catch (err) {
      console.error('Failed to save profile:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleSkip = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      await fetch(`${API_URL}/api/auth/profile`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });
    } catch (err) {
      // ignore
    }
    onSkip();
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="onboarding-modal">
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl max-w-md w-full p-6 relative">
        <button
          onClick={handleSkip}
          className="absolute top-4 right-4 text-zinc-500 hover:text-zinc-300 transition-colors"
          data-testid="onboarding-skip-x"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="mb-6">
          <h2 className="text-xl font-semibold text-white mb-1">
            Help us personalise your experience
          </h2>
          <p className="text-zinc-400 text-sm">
            Totally optional — you can always update this later in Settings.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-zinc-400 text-xs font-medium mb-1.5 flex items-center gap-1.5">
              <Building2 className="w-3.5 h-3.5" />
              Company / Organisation
            </label>
            <input
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="e.g. Acme Corp"
              className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2.5 text-white text-sm placeholder:text-zinc-600 focus:border-zinc-500 focus:outline-none transition-colors"
              data-testid="onboarding-company-input"
            />
          </div>

          <div>
            <label className="text-zinc-400 text-xs font-medium mb-1.5 flex items-center gap-1.5">
              <Briefcase className="w-3.5 h-3.5" />
              Job Title / Role
            </label>
            <input
              type="text"
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              placeholder="e.g. Engineering Manager"
              className="w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2.5 text-white text-sm placeholder:text-zinc-600 focus:border-zinc-500 focus:outline-none transition-colors"
              data-testid="onboarding-jobtitle-input"
            />
          </div>

          <div className="flex items-center gap-3 pt-2">
            <button
              type="submit"
              disabled={saving}
              className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg text-sm transition-colors disabled:opacity-50"
              data-testid="onboarding-save-button"
            >
              {saving ? 'Saving...' : 'Continue'}
              {!saving && <ChevronRight className="w-4 h-4" />}
            </button>
            <button
              type="button"
              onClick={handleSkip}
              className="px-4 py-2.5 text-zinc-500 hover:text-zinc-300 text-sm transition-colors"
              data-testid="onboarding-skip-button"
            >
              Skip for now
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OnboardingModal;
